import React, { useMemo } from "react";
import Modal from "./Modal";

const CATEGORY_OPTIONS = [
  { value: "purchase", label: "Purchase" },
  { value: "repair", label: "Repair" },
  { value: "maintenance", label: "Maintenance" },
  { value: "bills", label: "Bills" },
  { value: "wages", label: "Wages" },
  { value: "rent", label: "Rent" },
  { value: "other", label: "Other" },
];

export default function EditExpenseModal({
  isOpen,
  isSubmitting,
  formData,
  setFormData,
  onClose,
  onSubmit,
}) {
  const finalCategory = useMemo(() => {
    return formData.category === "other"
      ? (formData.other_category || "").trim()
      : formData.category;
  }, [formData.category, formData.other_category]);

  if (!isOpen) return null;

  return (
    <Modal
      title="Edit Expense"
      onClose={onClose}
      onSubmit={(e) => onSubmit(e, finalCategory)}
      submitButtonText={isSubmitting ? "Saving..." : "Update Expense"}
      showCancel={true}
      showSubmitButton={true}
      className="max-w-2xl"
      submitButtonClass="bg-indigo-600 hover:bg-indigo-700 text-white"
    >
      <div className="space-y-5">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <label className="mb-2 block text-sm font-semibold text-slate-700">
              Date *
            </label>
            <input
              type="date"
              value={formData.expense_date}
              onChange={(e) =>
                setFormData((p) => ({ ...p, expense_date: e.target.value }))
              }
              className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm outline-none transition focus:border-slate-500 focus:ring-4 focus:ring-slate-100"
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-slate-700">
              Amount (£) *
            </label>
            <input
              type="number"
              min="0"
              step="0.01"
              placeholder="0.00"
              value={formData.amount}
              onChange={(e) =>
                setFormData((p) => ({ ...p, amount: e.target.value }))
              }
              className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm outline-none transition focus:border-slate-500 focus:ring-4 focus:ring-slate-100"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <label className="mb-2 block text-sm font-semibold text-slate-700">
              Category *
            </label>
            <select
              value={formData.category}
              onChange={(e) => {
                const v = e.target.value;
                setFormData((p) => ({
                  ...p,
                  category: v,
                  other_category: v === "other" ? p.other_category : "",
                }));
              }}
              className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm outline-none transition focus:border-slate-500 focus:ring-4 focus:ring-slate-100"
            >
              <option value="">Select Category</option>
              {CATEGORY_OPTIONS.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </select>
          </div>

          {formData.category === "other" ? (
            <div>
              <label className="mb-2 block text-sm font-semibold text-slate-700">
                Other Category *
              </label>
              <input
                type="text"
                placeholder="e.g. Generator Fuel"
                value={formData.other_category}
                onChange={(e) =>
                  setFormData((p) => ({
                    ...p,
                    other_category: e.target.value,
                  }))
                }
                className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm outline-none transition focus:border-slate-500 focus:ring-4 focus:ring-slate-100"
              />
            </div>
          ) : (
            <div />
          )}
        </div>

        <div>
          <label className="mb-2 block text-sm font-semibold text-slate-700">
            Description / Note
          </label>
          <textarea
            placeholder="Write a short note about this expense..."
            value={formData.description}
            onChange={(e) =>
              setFormData((p) => ({ ...p, description: e.target.value }))
            }
            rows={4}
            className="w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm outline-none transition focus:border-slate-500 focus:ring-4 focus:ring-slate-100"
          />
        </div>
      </div>
    </Modal>
  );
}